import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import jwt_decode from "jwt-decode";

export const validateToken = createAsyncThunk(
  "validateToken",
  async ({ token, name }) => {
    console.log("token", token, name);
    try {
      jwt_decode(token);
      localStorage.setItem("jwtTokenSingh", token);
      localStorage.setItem("userNameSingh", name);
      return true;
    } catch (error) {
      return false;
    }
  }
);

const initialState = {
  // userNameSingh: localStorage.getItem("userNameSingh") || null,
  // jwtTokenSingh: localStorage.getItem("jwtTokenSingh") || null,
  loginStatus: localStorage.getItem("jwtTokenSingh") ? true : false,
  // loginStatus: isTokenValid(localStorage.getItem("jwtTokenSingh")),
  userAuthInfo: null,
  isLoadingAuth: true,
};

const userAuthSlice = createSlice({
  name: "userAuth",
  initialState: initialState,
  reducers: {
    loginUser(state, action) {
      state.loginStatus = action.payload.Token ? true : false;
      state.userAuthInfo = action.payload.Token ? action.payload : null;
      state.isLoading = false;
    },
    logoutUser(state, action) {
      localStorage.clear();
      state.loginStatus = false;
      state.userAuthInfo = null;
      state.isLoading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateToken.pending, (state) => {
        state.isLoadingAuth = true;
      })
      .addCase(validateToken.fulfilled, (state, action) => {
        state.loginStatus = action.payload;
        state.isLoadingAuth = false;
      });
  },
});

export const { loginUser, logoutUser } = userAuthSlice.actions;
export default userAuthSlice.reducer;
